import { API_BASE_URL } from './api';

const DEFAULT_UPLOAD_BASE_URL = 'http://localhost:3040';

const normalizeBaseUrl = (value) => {
  if (typeof value !== 'string') {
    return '';
  }

  const trimmed = value.trim();
  if (!trimmed) {
    return '';
  }

  return trimmed.replace(/\/+$/, '');
};

const configuredUploadBaseUrl = normalizeBaseUrl(process.env.REACT_APP_UPLOAD_IMAGE_BASE_URL);
const configuredApiBaseUrl = normalizeBaseUrl(API_BASE_URL);

export const FILE_BASE_URL =
  configuredUploadBaseUrl || configuredApiBaseUrl || DEFAULT_UPLOAD_BASE_URL;

export const resolveFileUrl = (value) => {
  if (!value && value !== 0) {
    return null;
  }

  const trimmed = String(value).trim();
  if (!trimmed) {
    return null;
  }

  if (/^(blob:|data:)/i.test(trimmed)) {
    return trimmed;
  }

  if (/^https?:\/\//i.test(trimmed)) {
    return trimmed;
  }

  if (/^\/\//.test(trimmed)) {
    return `https:${trimmed}`;
  }

  if (!FILE_BASE_URL) {
    return trimmed;
  }

  const normalizedPath = trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
  return `${FILE_BASE_URL}${normalizedPath}`;
};

export const resolveFileFromCandidates = (...candidates) => {
  for (const candidate of candidates) {
    const resolved = resolveFileUrl(candidate);
    if (resolved) {
      return resolved;
    }
  }

  return null;
};

